import {Chessboard, PieceDropHandlerArgs} from 'react-chessboard';
import {useRef, useState} from "react";
import { Chess } from 'chess.js'

export default function SimpleChess () {
  const chessGameRef = useRef(new Chess());
  const chessGame = chessGameRef.current;

  // track the current position of the chess game in state to trigger a re-render of the chessboard
  const [chessPosition, setChessPosition] = useState(chessGame.fen());

  // handle piece drop
  function onPieceDrop({
     sourceSquare,
     targetSquare
   }: PieceDropHandlerArgs) {
    if (!targetSquare) {
      return false;
    }

    try {
      chessGame.move({
        from: sourceSquare,
        to: targetSquare,
        promotion: 'q'
      });

      setChessPosition(chessGame.fen());
      return true;
    } catch {
      return false;
    }
  }

  // set the chessboard options
  const chessboardOptions = {
    position: chessPosition,
    onPieceDrop,
    id: 'play-vs-random'
  };

  // render the chessboard
  return (
    <Chessboard options={chessboardOptions} />
  );
}